
import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {I18nModule} from "../../i18n/i18n.module";
import {NavigationComponent} from "./navigation.component";
import {SmartMenuDirective} from "./smart-menu.directive";
import {UserModule} from "../../user/user.module";
import {RouterModule} from "@angular/router";
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { CustomDownloadModule } from "@app/cp/shared/components/custom-downloads/custom.download.module";
import { WindowModule, DialogsModule, DialogModule } from '@progress/kendo-angular-dialog';
import { SharedComponentsModule } from '@app/cp/shared/sharedComponents.module';
import { ReportAccessPipe } from "@app/cp/shared/pipes/report-access.pipe";

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        I18nModule,
        UserModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatIconModule,
        MatListModule,
        CustomDownloadModule,
        WindowModule,
        DialogModule,
        SharedComponentsModule,
        ReportAccessPipe,
    ],
  declarations: [
    NavigationComponent,
    SmartMenuDirective,
  ],
  exports: [
    NavigationComponent,
    SmartMenuDirective,
  ]
})
export class NavigationModule{}
